import keyMirror from 'keymirror';

export const tutorChatTypes = keyMirror({
	SET_AI_CHAT_DATA: null,

	AI_CHAT_INIT: null,
	AI_CHAT_INIT_SUCCESS: null,
	AI_CHAT_INIT_ERROR: null,
	GET_AI_CHAT_HISTORY: null,
	GET_AI_CHAT_HISTORY_SUCCESS: null,
	GET_AI_CHAT_HISTORY_ERROR: null,

	STOP_AI_EVENT_STREAM: null,
	AI_EVENT_STREAM_MESSAGE: null,

	AI_CONVERSATION: null,
	AI_CONVERSATION_ERROR: null,

	AI_TUTOR_ANALYTICS: null,

	CLEAR_AI_CHAT_STATE: null,
});

export const isTutorsAvailableTime = () => {
	const now = new Date();
	const options = { timeZone: 'Europe/Amsterdam', hour12: false };
	const timeStr = now.toLocaleTimeString('en-GB', options);
	const timeParts = timeStr.split(':');
	const hours = parseInt(timeParts[0], 10);

	return hours >= 15 && hours < 22;
};
